import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "platformIcon", "status", "hint", "preview", "thumbnail"]

  static YOUTUBE_PATTERNS = [
    /(?:youtube\.com\/watch\?.*v=)([a-zA-Z0-9_-]{11})/,
    /youtu\.be\/([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/v\/([a-zA-Z0-9_-]{11})/
  ]

  static VIMEO_PATTERNS = [
    /vimeo\.com\/(\d+)/,
    /vimeo\.com\/video\/(\d+)/,
    /player\.vimeo\.com\/video\/(\d+)/
  ]

  connect() {
    this.validate()
  }

  validate() {
    const url = this.inputTarget.value.trim()

    if (!url) {
      this.hideStatus()
      this.hidePreview()
      return
    }

    const youtubeId = this.extractYoutubeId(url)
    if (youtubeId) {
      this.showYoutube(youtubeId)
      return
    }

    const vimeoId = this.extractVimeoId(url)
    if (vimeoId) {
      this.showVimeo(vimeoId)
      return
    }

    this.showError()
  }

  extractYoutubeId(url) {
    for (const pattern of this.constructor.YOUTUBE_PATTERNS) {
      const match = url.match(pattern)
      if (match) return match[1]
    }
    return null
  }

  extractVimeoId(url) {
    for (const pattern of this.constructor.VIMEO_PATTERNS) {
      const match = url.match(pattern)
      if (match) return match[1]
    }
    return null
  }

  showYoutube(videoId) {
    this.platformIconTarget.innerHTML = this.youtubeIcon()
    this.platformIconTarget.classList.remove("hidden")

    this.statusTarget.innerHTML = `<span class="text-green-600">YouTube video detected</span>`

    if (this.hasPreviewTarget && this.hasThumbnailTarget) {
      this.thumbnailTarget.src = `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`
      this.previewTarget.classList.remove("hidden")
    }
  }

  showVimeo(videoId) {
    this.platformIconTarget.innerHTML = this.vimeoIcon()
    this.platformIconTarget.classList.remove("hidden")

    this.statusTarget.innerHTML = `<span class="text-green-600">Vimeo video detected</span>`

    // Vimeo thumbnails require API call, hide preview
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
    }
  }

  showError() {
    this.platformIconTarget.classList.add("hidden")
    this.statusTarget.innerHTML = `<span class="text-red-600">Only YouTube and Vimeo URLs are supported</span>`
    this.hidePreview()
  }

  hideStatus() {
    this.platformIconTarget.classList.add("hidden")
    this.statusTarget.innerHTML = ""
  }

  hidePreview() {
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.add("hidden")
    }
  }

  youtubeIcon() {
    return `<svg class="h-5 w-5 text-red-600" viewBox="0 0 24 24" fill="currentColor">
      <path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"/>
    </svg>`
  }

  vimeoIcon() {
    return `<svg class="h-5 w-5 text-[#1ab7ea]" viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.977 6.416c-.105 2.338-1.739 5.543-4.894 9.609-3.268 4.247-6.026 6.37-8.29 6.37-1.409 0-2.578-1.294-3.553-3.881L5.322 11.4C4.603 8.816 3.834 7.522 3.01 7.522c-.179 0-.806.378-1.881 1.132L0 7.197c1.185-1.044 2.351-2.084 3.501-3.128C5.08 2.701 6.266 1.984 7.055 1.91c1.867-.18 3.016 1.1 3.447 3.838.465 2.953.789 4.789.971 5.507.539 2.45 1.131 3.674 1.776 3.674.502 0 1.256-.796 2.265-2.385 1.004-1.589 1.54-2.797 1.612-3.628.144-1.371-.395-2.061-1.614-2.061-.574 0-1.167.121-1.777.391 1.186-3.868 3.434-5.757 6.762-5.637 2.473.06 3.628 1.664 3.493 4.797l-.013.01z"/>
    </svg>`
  }
}
